<template>
  <div class="home" :style="{ backgroundColor: bgColor }">
    <!-- 状态栏   -->
    <status-bar></status-bar>
    <!-- 导航栏 -->
    <activity-nav :backFn="_back"></activity-nav>

    <!-- 站外引导 -->
    <out-side v-if="isOutSide"></out-side>

    <div v-if="h5ConfigDetails" class="content" :style="`height: calc(100vh - 4.2rem - ${statusBarHeight}${isInIos ? 'px' : 'vh'});`">

      <!-- 头图部分 -->
      <head-diagram :showOperate="_show_rules" @login="_login"></head-diagram>

      <!-- 倒计时模块 -->
      <count-down v-if="h5ConfigDetails[0]['modalOrder']['CountDownOrder'][0] !== '-1'"></count-down>

      <!-- 主页产品模块 -->
      <products-home v-if="h5ConfigDetails[0]['modalOrder']['ProductsHomeOrder'][0] !== '-1'" :login="_login"></products-home>

      <!-- 领取礼包模块 -->
      <coupons-home v-if="h5ConfigDetails[0]['modalOrder']['CouponsHomeOrder'][0] !== '-1'" ref="couponsHome" :loginFn="_login"></coupons-home>

      <!-- 中奖信息模块 -->
      <prizes-info v-if="h5ConfigDetails[0]['modalOrder']['PrizesInfoOrder'][0] !== '-1'"></prizes-info>

      <!-- 抽奖模块 -->
      <draw-lottery v-if="h5ConfigDetails[0]['modalOrder']['DrawLotteryOrder'][0] !== '-1'" ref="drawLottery" :login="_login"></draw-lottery>

      <!-- 奖品展示 -->
      <prizes-show v-if="h5ConfigDetails[0]['modalOrder']['PrizesShowOrder'][0] !== '-1'"></prizes-show>

      <!-- 吸底按钮 -->
      <bottom-btn v-if="h5ConfigDetails[0]['modalOrder']['BottomBtnOrder'][0] !== '-1'"></bottom-btn>

      <!-- 吸底按钮 -->
      <bottom-banner v-if="h5ConfigDetails[0]['modalOrder']['BottomBannerOrder'][0] !== '-1'" :loginFn="_login"></bottom-banner>

      <task-home v-if="h5ConfigDetails[0]['modalOrder']['TaskHomeOrder'][0] !== '-1'" :loginFn="_login"></task-home>
    
      <!-- 挽留弹窗 -->
      <no-leaving ref="noLeaving"></no-leaving>

      <!-- 吸底购买按钮 -->
      <pay-panel-bottom ref="payPanelBottom"></pay-panel-bottom>

    </div>
    
    <!-- 以下是弹窗组件 -->
    <!-- 错误 -->
    <error-win ref="errorWin"></error-win>

    <!-- 活动结束/未开始 -->
    <activity-over ref="activityOver"></activity-over>

    <!-- 低版本提示 -->
    <keep-out ref="keepOut"></keep-out>

    <!-- 活动规则 -->
    <activity-rules ref="activityRules"></activity-rules>

    <!-- loading -->
    <loading-show ref="loadingShow"></loading-show>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store/index'
import appBridge from '@/config/appBridge'
import StatusBar from '@/components/navigation/StatusBar'
import ActivityNav from '@/components/navigation/ActivityNav'
import HeadDiagram from '@/components/home/HeadDiagram'
import CountDown from '@/components/home/CountDown'
import ProductsHome from '@/components/home/ProductsHome'
import CouponsHome from '@/components/home/CouponsHome'
import TaskHome from '@/components/home/TaskHome'
import PrizesInfo from '@/components/home/PrizesInfo'
import DrawLottery from '@/components/home/DrawLottery'
import PrizesShow from '@/components/home/PrizesShow'
import BottomBtn from '@/components/home/BottomBtn'
import BottomBanner from '@/components/home/BottomBanner'
import ErrorWin from '@/components/modal/ErrorWin'
import ActivityOver from '@/components/modal/ActivityOver'
import KeepOut from '@/components/modal/KeepOut'
import ActivityRules from '@/components/modal/ActivityRules'
import PayPanelBottom from '@/components/modal/PayPanelBottom'
import LoadingShow from '@/components/modal/LoadingShow'
import OutSide from '@/components/modal/OutSide'
import NoLeaving from '@/components/modal/NoLeaving'
import { getActivitys, getPortalConfig, getCouponsByUserId, getCouponList, getTasksByUserId } from '@/service/apis'
import { global, DOWNLOAD_URL } from '@/config/global'
import { $isXunMengTu } from '@/util/util'

export default {
  name: 'HomeView',
  data () {
    return {
      // portal注入的图片及文案信息
      h5ConfigDetails: null,
      h5ConfigImgPath: '',
      bgColor: '#fff'
    }
  },
  components: {
    StatusBar, ActivityNav, HeadDiagram, ProductsHome, PrizesInfo, DrawLottery, PrizesShow, BottomBtn, BottomBanner, ErrorWin, ActivityOver, KeepOut,
      ActivityRules, PayPanelBottom, LoadingShow, CouponsHome, TaskHome, OutSide, CountDown, NoLeaving
  },
  computed: {
    ...mapState(['statusBarHeight', 'isInIos', 'userInfo', 'appVersion', 'isLogin', 'activityConfig', 'productList', 'couponsHistory', 'isOutSide', 'activityID'
      , 'hasClickLotteryBtn', 'hasClickBottomBuyBtn', 'hasFinishPayAction'
    ])
  },
  created () {
    if(!$isXunMengTu() && !this.isInIos) {
      appBridge.needInterruptBack() // 此页面需要中断返回
    }
    window.eventBus.$on('onWebviewBack', () => {
      this._back()
    })
    document.title = $isXunMengTu() ? '迅猛兔手游加速器' : '迅游手游加速器'
    this.init()
    window.eventBus.$on('refresh', () => { // 用户跳转回来刷新数据
      this._init_coupons_data()
    })
  },
  mounted () {
    this.$sensors.track('app_page_show')

    this._bind_custom_event()
  },
  methods: {
    init () {
      // 设置活动id
      store.commit('SET_ACTIVITY_ID', this.$route.query.app_activity_id)
      // 获取数据 from APP
      this._get_data_from_app()
      // 获取数据 from Service
      this._get_data_from_service()
    },
    
    _get_data_from_app () {
      store.commit('SET_DATA_FROM_APP')
    },

    // 获取服务端接口数据
    async _get_data_from_service () {
      if (!this.isOutSide && !$isXunMengTu()) {
        const data = await window.fetchProductListData(this.isInIos)
        store.commit('SET_PRODUCT_LIST', data)
      } else {
        store.commit('SET_PRODUCT_LIST', [])
      }

      let activityConfigs = await getActivitys()
      let activityConfig = activityConfigs.find(cur => {
        return cur.activityId === this.activityID
      })
      // 配置校验
      if (!activityConfig) {
        this.$nextTick(() => {
          this.$refs.errorWin.show(global.ERROR_CODE_ACTIVITYID_ERROR)
        })
        // throw new Error('Wrong config!')
      } else {
        store.commit('SET_ACTIVITY_CONFIG', activityConfig)
      }
      // 活动结束/未开始
      if (activityConfig && (activityConfig.startTime > new Date().getTime() || new Date().getTime() > activityConfig.endTime)) {
        this.$nextTick(() => {
          this.$refs.activityOver.show()
        })
        return
      }

      this._get_portal_config()
    },

    async _get_portal_config () {
      await getPortalConfig(this.activityConfig.h5Config)
      // 处理portal/h5Config数据
      this.h5ConfigDetails = window.h5ConfigDetails
      this.h5ConfigImgPath = `${this.activityConfig.h5Config}A`
      this.bgColor = this.h5ConfigDetails[0]['fontColor']['activityBg'][0]
      store.commit('SET_RATIO_INFO', {h5ConfigDetails: this.h5ConfigDetails, h5ConfigImgPath: this.h5ConfigImgPath})

      if (this._check_out_app()) {
        return
      }

      // 判断版本是否支持
      if (!this._check_version(window.h5ConfigDetails[0]['activitySetting'][this.isInIos ? 'appVersionIos' : 'appVersionAndroid'][0])) {
        this.$nextTick(() => {
          this.$refs.keepOut.show()
        })
      } else {
        this._init_coupons_data()
      }
    },

    _init_coupons_data () {
      Promise.all([this._get_coupon_list(), this._get_coupons_history(), this._get_task_history()]).then(result => {
        store.commit('SET_COUPON_LIST', result[0])
        store.commit('SET_COUPONS_HISTORY', result[1])
        store.commit('SET_TASK_LIST', result[2].taskList || [])
        this.$nextTick(() => {
          if (this.h5ConfigDetails[0]['modalOrder']['DrawLotteryOrder'][0] !== '-1'){
            this.$refs.drawLottery.init()
          }
          // this.$refs.couponsHome._create_coupons()
        })
      }).catch((errorTxt) => {
        console.error(errorTxt)
        if (this.isLogin) {
          this.$refs.errorWin.show(global.ERROR_CODE_UNDEFINED)
        }
        // this.$refs.errorWin.show(global.ERROR_CODE_UNDEFINED)
      })
    },

    _check_out_app () {
      if (this.isOutSide) {
        store.commit('SET_COUPON_LIST', null)
        store.commit('SET_COUPONS_HISTORY', null)
        store.commit('SET_TASK_LIST', null)
        return true
      }

      return false
    },

    _get_coupon_list () {
      return getCouponList()
    },
    
    _get_coupons_history () {
      return getCouponsByUserId(this.userInfo.userId)
    },

    _get_task_history () {
      return getTasksByUserId(this.userInfo.userId)
    },

    _check_version (versionNum) {
      return !!versionNum && this.appVersion >= versionNum
    },

    _show_rules () {
      this.$sensors.track('app_page_click', {button_name: 'rules'})
      this.$nextTick(() => {
        this.$refs.activityRules.show()
      })
    },

    // 判断用户是否已经登录
    _is_login () {
      if (this.isLogin) return true

      this._login()
    },

    // 跳转到登录页面
    _login () {
      if (this.isOutSide) {
        if(this.isInIos && $isXunMengTu()){
          window.location.href = DOWNLOAD_URL.XMT_IOS
        } else if(this.isInIos && !$isXunMengTu()) {
          window.location.href = DOWNLOAD_URL.IOS
        } else if(!this.isInIos && $isXunMengTu()) {
          window.location.href = DOWNLOAD_URL.XMT_ANDROID
        } else if(!this.isInIos && !$isXunMengTu()) {
          window.location.href = DOWNLOAD_URL.ANDROID
        }
      }
      
      this.$sensors.track('app_page_click', {button_name: 'log_in'})
      appBridge.turnToAppLoginPage()
    },

    _bind_custom_event () {
      window.eventBus.$on('refreshAfterPay', () => {
        if (this.isInIos) {
          this._get_data_from_app()
        }
        this._init_coupons_data()
      })

      window.eventBus.$on('tokenChanged', () => {
        this.init()
      })
    },
    _back () {
      // 迅猛兔不参与挽留弹窗业务
      if ($isXunMengTu()) {
        if (this.isInIos) {
          appBridge.refreshAppToken()
        }
        appBridge.closeWebView()
        return
      }
      
      const mark = JSON.parse(localStorage.getItem(`${global.LOCAL_STORAGE_NO_LEAVING}-${this.activityID}`))
      // check portal 配置是否允许
      if (!this.h5ConfigDetails[0].noLeavingWinPicture.isShow || !Number(this.h5ConfigDetails[0].noLeavingWinPicture.isShow[0])) {
        appBridge.closeWebView()
        return
      }

      // a. 之前弹过“挽留弹窗”不再弹
      if (mark) {
        appBridge.closeWebView()
        return
      }

      // b. 点击过抽奖但未完成支付得用户
      if (this.hasClickLotteryBtn && !this.hasFinishPayAction) {
        this.$refs.noLeaving.show()
        return
      }

      // c. 点击过立即购买但未完成支付得用户
      if (this.hasClickBottomBuyBtn && !this.hasFinishPayAction) {
        this.$refs.noLeaving.show()
        return
      }

      appBridge.closeWebView()
    }
  }
}
</script>
<style lang="less" scoped>
  .home {
    width: 100vw;
    height: 100vh;
    .content {
      position: relative;
      width: 100%;
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      font-size: 0;
    }
  }
</style>